import React from 'react';
import HelpContent from './HelpContent';
import HidrogenoAviones from 'img/avion_hidrogeno.PNG';

const HidrogenoAereoHelp = () => (
  <HelpContent>
    <h1>Introducción de hidrógeno en transporte aéreo</h1>
    <p>
    Esta medida evalúa el impacto de la introducción de Combustibles de Aviación Sostenibles (SAF) en el transporte aéreo nacional. Durante la tercera Conferencia sobre la Aviación y los Combustibles Alternativos (CAAF/3) de la Organización de Aviación Civil Internacional (OACI) en noviembre de 2023, 
    se estableció un marco global para avanzar hacia una transición energética sostenible en la aviación a nivel mundial. 
    En este marco, los Estados miembros se comprometieron a reducir en un 5% las emisiones de CO2 en la aviación internacional para 2030 en comparación con un escenario sin el uso de energías limpias, 
    y a fomentar la producción de SAF en todas las regiones. En Chile, la Hoja de Ruta SAF plantea que los SAF representen el 50% 
    del uso de combustible utilizado en la aviación nacional e internacional de Chile 2050. 

    </p>
	<img src={HidrogenoAviones} alt="Hidrógeno en transporte aéreo" />
    <label>Figura: Avión a hidrógeno AirbusZEROe. Fuente: Airbus https://www.airbus.com/newsroom/press-releases/en/2020/09/airbus-reveals-new-zeroemission-concept-aircraft.html  </label>
    
    <p>
      <strong>Trayectoria 1:</strong> importación de Bio-SPK  en el año 2027 hasta alcanzar el 1% de participación al año 2030. En 2035 hay una participación de 8,3% de Bio-SPK y 1,3% de e-fuels,
       en 2040 14.5% de Bio-SPK y 7,5% de e-fuels y en 2050 30% de Bio-SPK y 20% de e-fuels.
    </p>
  </HelpContent>
);

export default HidrogenoAereoHelp;
